import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ICON = (color) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${color};width:18px;height:18px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.3)"></div>`,
    iconSize: [18, 18],
    iconAnchor: [9, 18],
  });

export function MapView({ pickup, destination, height = 320 }) {
  const ref = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);

  useEffect(() => {
    if (map.current || !ref.current) return;
    map.current = L.map(ref.current, { zoomControl: true, scrollWheelZoom: false })
      .setView([45.4642, 9.19], 5);
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19, attribution: "&copy; OpenStreetMap" }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    return () => { if (map.current) { map.current.remove(); map.current = null; } };
  }, []);

  useEffect(() => {
    if (!map.current || !layer.current) return;
    layer.current.clearLayers();
    const pts = [];
    if (pickup?.lat) { L.marker([pickup.lat, pickup.lon], { icon: ICON("#1d4ed8") }).addTo(layer.current); pts.push([pickup.lat, pickup.lon]); }
    if (destination?.lat) { L.marker([destination.lat, destination.lon], { icon: ICON("#b45309") }).addTo(layer.current); pts.push([destination.lat, destination.lon]); }
    if (pts.length === 2) {
      L.polyline(pts, { color: "#1e3a8a", weight: 3, dashArray: "6 8", opacity: 0.7 }).addTo(layer.current);
      map.current.fitBounds(pts, { padding: [40, 40] });
    } else if (pts.length === 1) {
      map.current.setView(pts[0], 11);
    }
    setTimeout(() => map.current && map.current.invalidateSize(), 100);
  }, [pickup?.lat, pickup?.lon, destination?.lat, destination?.lon]);

  return <div ref={ref} style={{ height }} className="w-full rounded-xl overflow-hidden border border-slate-200" data-testid="map-view" />;
}
